import PriceControlForBundle from "./PriceControlForBundle";

export default PriceControlForBundle;



// WEBPACK FOOTER //
// ./src/components/AgGridPriceForBundle/index.js